 
import React, { useState } from 'react';
import Text from 'v3/components/Text';
import Input from 'v3/components/Input';
import Button from 'v3/components/Button';
import { Row, Col } from 'react-bootstrap';
import { CNPJ_MASK } from 'v3/utils/masks';

function Filter({ fetch }) {
  const [name, setName] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        fetch(name, documentNumber);
      }}
    >
      <Row className="filter">
        <Col lg={6} xs={12}>
          <Input
            label="Nome"
            labelColor="#fff"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Col>
        <Col lg={4} xs={12}>
          <Input
            label="CNPJ"
            labelColor="#fff"
            value={documentNumber}
            onChange={(event) => setDocumentNumber(event.target.value.toUpperCase())}
            masked
            guide={false}
            mask={CNPJ_MASK}
          />
        </Col>
        <Col lg={2} xs={12} className="vertical bottom">
          <Button type="submit" variant="success" className="w-100">
            <Text type="regular">Filtrar</Text>
          </Button>
        </Col>
      </Row>
    </form>
  );
}

export default Filter;